import React, { useEffect } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import OptimizedImage from '../OptimizedImage';

// Full-viewport image lightbox used by RoomDetail. Handles keyboard nav
// (Escape/Arrow) via effect that mounts only while `open` is true.
export const ImageLightbox = ({ open, images, currentIndex, onIndexChange, onClose, alt = 'Room' }) => {
  useEffect(() => {
    if (!open) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onIndexChange((currentIndex + 1) % images.length);
      if (e.key === 'ArrowLeft') onIndexChange((currentIndex - 1 + images.length) % images.length);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [open, currentIndex, images.length, onClose, onIndexChange]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center" onClick={onClose}>
      <button
        onClick={onClose}
        className="absolute top-4 right-4 bg-white text-gray-900 p-3 rounded-full shadow-xl hover:bg-gray-100 z-50 transition-all"
        data-testid="lightbox-close-btn"
      >
        <X size={28} strokeWidth={3} />
      </button>

      <div className="absolute top-4 left-4 text-white/70 text-sm z-50">
        Press ESC or click outside to close
      </div>

      <button
        onClick={(e) => { e.stopPropagation(); onIndexChange((currentIndex - 1 + images.length) % images.length); }}
        className="absolute left-4 p-3 bg-white/10 hover:bg-white/20 rounded-full z-10"
      >
        <ChevronLeft size={40} className="text-white" />
      </button>

      <OptimizedImage
        src={images[currentIndex]}
        alt={`${alt} - Photo ${currentIndex + 1}`}
        className="max-h-[85vh] max-w-[90vw] object-contain"
        onClick={(e) => e.stopPropagation()}
      />

      <button
        onClick={(e) => { e.stopPropagation(); onIndexChange((currentIndex + 1) % images.length); }}
        className="absolute right-4 p-3 bg-white/10 hover:bg-white/20 rounded-full z-10"
      >
        <ChevronRight size={40} className="text-white" />
      </button>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white text-lg font-semibold">
        {currentIndex + 1} / {images.length}
      </div>
    </div>
  );
};
